import React from 'react';
import isElementOfType from './isElementOfType';
/**
 * Wraps `element` in `Component`, if it is not already an instance of `Component`.
 * If `props` is passed, those will be added as props on the wrapped component.
 * If `element` is null, the component will not be wrapped.
 * @param {ReactElement} element
 * @param {ReactComponent} component
 * @param {Object} props
 */

export default function wrapElementWithComponent(element, Component, props) {
  if (element == null) return null;
  if (isElementOfType(element, Component)) return element;
  return /*#__PURE__*/React.createElement(Component, props, element);
}